import React from 'react';

import { AutocompleteField } from '~/components/core/AutocompleteField/AutocompleteField';
import useAutocomplete from '~/hooks/useAutocomplete';
import type { AutocompleteResponseBaseModelRuleOptionRuleOption } from '~/server_shared/openapi/data-contracts';

interface RuleNameAutocompleteProps {
  organizationId: number;
  value: string; // Display value (rule name)
  onChange: (ruleId: string, ruleName: string) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
}

export const RuleNameAutocomplete: React.FC<RuleNameAutocompleteProps> = ({
  organizationId,
  value,
  onChange,
  label = 'Rule Name',
  className,
  disabled = false,
}) => {
  const { suggestions, isLoading, fetchSuggestions } =
    useAutocomplete<AutocompleteResponseBaseModelRuleOptionRuleOption>({
      organizationId,
      fetchUrl: `/api/v1/automation/workflow_engine/executions/organizations/${organizationId}/rule_options/autocomplete`,
      limit: 10,
    });

  const handleChange = (id: string | number, name: string) => {
    onChange(String(id), name);
  };

  return (
    <AutocompleteField<AutocompleteResponseBaseModelRuleOptionRuleOption>
      id="rule-name-autocomplete"
      label={label}
      value={value}
      onChange={handleChange}
      options={suggestions}
      loading={isLoading}
      onInputChange={fetchSuggestions}
      className={className}
      disabled={disabled}
    />
  );
};
